export const REPLY_SUBJECT_PREFIX = 'Re:';
export const FORWARD_SUBJECT_PREFIX = 'Fwd:';
